import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react";
import { looseDiamondId, looseStoneId } from "utils/helpers";

const data4 = [
  {
    srNo: "01",
    itemDetails: "Purchase Gold, Bangles, Navratna Bang, BN100",
    totalWt: "100.000",
    grossWt: "800.000",
    stoneWt: "000.000",
    netWt: "000.000",
    finePercent: "10",
    wastagePercent: "10",
    fPlusWWt: "120.000",
    ratePer10Gm: "80000.00",
    stoneAmt: "5000.00",
    qty: "2",
    hallmarkAmt: "100",
    totalItemAmt: "50,00,000.00",
    packingWt: "10.000",
    diamondWt: "121.000",
  },
  {
    srNo: "02",
    itemDetails: "Purchase",
    totalWt: "100.000",
    grossWt: "200.000",
    stoneWt: "000.000",
    netWt: "000.000",
    finePercent: "10",
    wastagePercent: "10",
    fPlusWWt: "120.000",
    ratePer10Gm: "80000.00",
    stoneAmt: "5000.00",
    qty: "4",
    hallmarkAmt: "100",
    totalItemAmt: "50,00,000.00",
    packingWt: "20.000",
    diamondWt: "121.000",
  },
  {
    srNo: "03",
    itemDetails: "Purchase",
    totalWt: "100.000",
    grossWt: "200.000",
    stoneWt: "000.000",
    netWt: "000.000",
    finePercent: "10",
    wastagePercent: "10",
    fPlusWWt: "120.000",
    ratePer10Gm: "80000.00",
    stoneAmt: "5000.00",
    qty: "4",
    hallmarkAmt: "100",
    totalItemAmt: "50,00,000.00",
    packingWt: "20.000",
    diamondWt: "121.000",
  },
  {
    srNo: "04",
    itemDetails: "Purchase",
    totalWt: "100.000",
    grossWt: "200.000",
    stoneWt: "000.000",
    netWt: "000.000",
    finePercent: "10",
    wastagePercent: "10",
    fPlusWWt: "120.000",
    ratePer10Gm: "80000.00",
    stoneAmt: "5000.00",
    qty: "4",
    hallmarkAmt: "100",
    totalItemAmt: "50,00,000.00",
    packingWt: "20.000",
    diamondWt: "121.000",
  },
];
const totals = data4.reduce(
  (acc, row) => {
    acc.totalWt += parseFloat(row.totalWt);
    acc.grossWt += parseFloat(row.grossWt);
    acc.stoneWt += parseFloat(row.stoneWt);
    acc.netWt += parseFloat(row.netWt);
    acc.finePercent += parseFloat(row.finePercent);
    acc.wastagePercent += parseFloat(row.wastagePercent);
    acc.fPlusWWt += parseFloat(row.fPlusWWt);
    acc.stoneAmt += parseFloat(row.stoneAmt);
    acc.qty += parseFloat(row.qty);
    acc.hallmarkAmt += parseFloat(row.hallmarkAmt);
    acc.totalItemAmt += parseFloat(row.totalItemAmt.replace(/,/g, ""));
    acc.packingWt += parseFloat(row.packingWt);
    acc.diamondWt += parseFloat(row.diamondWt);
    return acc;
  },
  {
    totalWt: 0,
    grossWt: 0,
    stoneWt: 0,
    netWt: 0,
    finePercent: 0,
    wastagePercent: 0,
    fPlusWWt: 0,
    stoneAmt: 0,
    qty: 0,
    hallmarkAmt: 0,
    totalItemAmt: 0,
    packingWt: 0,
    diamondWt: 0,
  }
);

const DiamondSummary = ({
  skus,
  setIsSummaryOpen,
  setValue,
  setEditValues,
  setEdit,
}) => {
  const [total, setTotal] = useState({
    TotalStoneWt: 0,
    TotalStonePieces: 0,
    TotalStoneAmount: 0,
  });
  const handleDelete = (id) => {
    setValue(
      "skus",
      skus.filter((sku) => sku.id !== id)
    );
  };
  const handleEdit = (id) => {
    const data = skus.find((sku) => sku.id == id);
    setEditValues(data);
    setEdit(true);
    setIsSummaryOpen(false);
  };

  useEffect(() => {
    let totalSleve = 0;
    let totalWt = 0;
    let totalPieces = 0;
    let totalAmount = 0;
    

    skus?.forEach((item) => { 
        totalSleve += +item?.DiamondSleve
        totalWt += +item?.DiamondWeight
        totalPieces += +item?.DiamondPieces
        totalAmount += +item?.DiamondAmount
    });
    setValue("TotalTaxableAmount", totalAmount?.toFixed(3));

    setTotal({
      TotalDiamondWt: totalWt ? totalWt : 0,
      TotalDiamondPieces: totalPieces ? totalPieces : 0,
      TotalDiamondAmount: totalAmount ? totalAmount : 0,
      TotalSleve: totalSleve ? totalSleve : 0,
    });
  }, [skus]);
  console.log(skus)
  return (
    <div className="box1-section">
      <div
        className="table-container"
        style={{ overflowX: "auto", margin: "0", padding: "0", width: "100%" }}
      >
        <table className="custom-table">
          <thead>
            <tr>
              <th
                style={{
                  fontSize: "12px",
                  width: "200px",
                  minWidth: "200px",
                  textAlign: "left",
                  color: "#fff",
                }}
              >
                Item Details
              </th>
              <th style={{ fontSize: "12px", color: "#fff", }}>Diamond Shape</th>
              <th style={{ fontSize: "12px", color: "#fff", }}>Diamond Colour</th>
              <th style={{ fontSize: "12px", color: "#fff", }}>Diamond Clarity</th>
              <th style={{ fontSize: "12px", color: "#fff", }}>Diamond Sleve</th>
              <th style={{ fontSize: "12px", color: "#fff", }}>Diamond Size</th>
              <th style={{ fontSize: "12px", color: "#fff", }}>Diamond Weight</th>
              <th style={{ fontSize: "12px", color: "#fff", }}>Diamond Pieces</th>
              <th style={{ fontSize: "12px" , color: "#fff",}}>Diamond Rate</th>
              <th style={{ fontSize: "12px", color: "#fff", }}>Diamond Amount</th>
              <th style={{ fontSize: "12px", color: "#fff", }}>Diamond Cut</th>
              <th style={{ fontSize: "12px", color: "#fff", }}>Diamond Setting Type</th>
              <th style={{ fontSize: "12px", color: "#fff", }}>Diamond Certificate</th>
              <th style={{ fontSize: "12px", color: "#fff", }}>Diamond Packet</th>
              <th style={{ fontSize: "12px", color: "#fff", }}>Diamond Box</th>
              <th style={{ fontSize: "12px", color: "#fff", }}>Diamond Description</th>
            </tr>
          </thead>
          <tbody>
            {skus?.map((row) => (
                <tr key={row?.srNo}>
                <td>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "12px",
                    }}
                  >
                    <Icon
                      icon="lets-icons:img-box-fill"
                      width="24"
                      height="24"
                      style={{ flex: "1", color: "#627282", cursor: "pointer" }}
                    />
                    <div style={{ flex: "1" }}>
                      {row?.CategoryId?.value !== looseStoneId &&
                      row?.CategoryId?.value !== looseDiamondId ? (
                        <>
                          {row?.CategoryId?.label} - {row?.ProductId?.label} -{" "}
                          {row?.DesignId?.label} - {row?.PurityId?.label}
                        </>
                      ) : row?.CategoryId?.value == looseStoneId ||
                        row?.CategoryId?.value == looseDiamondId ? (
                        row?.CategoryId?.label
                      ) : (
                        ""
                      )}
                    </div>
                    <div
                      style={{
                        flex: "1",
                        display: "flex",
                        flexDirection: "column",
                      }}
                    >
                      <div
                        style={{ display: "flex", flexDirection: "column" }}
                        title="edit"
                        onClick={() => handleEdit(row.id)}
                      >
                        <Icon
                          title="edit"
                          icon="material-symbols-light:edit-outline"
                          width="15"
                          height="15"
                          style={{ color: "#627282", cursor: "pointer" }}
                        />
                      </div>
                      <div
                        style={{ display: "flex", flexDirection: "column" }}
                        title="delete"
                      >
                        <Icon
                          icon="weui:delete-outlined"
                          width="15"
                          height="15"
                          style={{ color: "#627282", cursor: "pointer" }}
                          onClick={() => {
                            handleDelete(row.id);
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.DiamondShape?.label}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.DiamondColour?.label}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.DiamondClarity?.label}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.DiamondSleve?.label}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.DiamondSize?.label}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.DiamondWeight}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.DiamondPieces}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.DiamondRate}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.DiamondAmount}
                </td>

                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.DiamondCut?.label}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.DiamondSettingType?.label}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.DiamondCertificate}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.DiamondPacket}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.DiamondBox}
                </td>
                <td style={{ fontSize: "12px", textAlign: "center" }}>
                  {row?.DiamondDescription}
                </td>
              </tr>
            ))}
            <tr>
              <td>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    fontSize: "12px",
                    gap: "5px",
                  }}
                >
                  <div></div>
                  <div
                    style={{ display: "flex", flexDirection: "column" }}
                    title="add more"
                  >
                    <Icon
                      icon="weui:add-outlined"
                      onClick={() => {
                        // reset
                        setEdit(false);
                        setIsSummaryOpen(false);
                      }}
                      width="15"
                      height="15"
                      style={{ color: "#627282", cursor: "pointer" }}
                    />
                  </div>
                </div>
              </td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
              <td style={{ fontSize: "12px", textAlign: "center" }}></td>
            </tr>
            <tr>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                Total
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              ></td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              ></td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              ></td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >{total?.TotalSleve}</td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {total?.TotalDiamondWt?.toFixed(3)}
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                {total?.TotalDiamondPieces?.toFixed(3)}
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              ></td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              >
                   {total?.TotalDiamondAmount?.toFixed(3)}
              </td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              ></td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              ></td>
              <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              ></td>
               <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              ></td>
               <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              ></td>
               <td
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                  padding: "8px 0px",
                }}
              ></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DiamondSummary;
